import { useAuth } from '@/context/auth'
import { getConfig } from '@/lib/config'
import { init, onAuthSuccess } from '@getsetup-io/html-embed'
import { useEffect } from 'react'

interface GsuHTMLEmbedProps {
  partnerId?: string
  page?: string
}

export const GsuHTMLEmbed: React.FC<GsuHTMLEmbedProps> = (props) => {
  const { publicRuntimeConfig } = getConfig()
  const {
    state: { user },
  } = useAuth()

  useEffect(() => {
    if (!props.partnerId || !props.page) return
    init({
      environment: publicRuntimeConfig.environment === 'production' ? 'production' : 'development',
      targetElementId: 'iframe-container',
      partnerId: props.partnerId,
      analyticsInfo: Buffer.from(JSON.stringify({ domain: publicRuntimeConfig.events.cookieDomain })).toString(
        'base64',
      ),
    })
  }, [props])

  useEffect(() => {
    if (!user?.id) return
    onAuthSuccess({
      userId: user.id,
      additionalInfo: {
        name: user.fullName,
        email: user.email,
      },
    })
  }, [user])

  return (
    <main>
      <div
        id="iframe-container"
        data-gsuembed-discover-link-template={`${props.page}/`}
        data-gsuembed-article-link-template={`${props.page}/article/[articleID]`}
        data-gsuembed-series-link-template={`${props.page}/series/[seriesID]`}
        data-gsuembed-watch-link-template={`${props.page}/watch/[classID]`}
      ></div>
    </main>
  )
}
